import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history'
})

// 移动端 H5 站点地址
const MOBILE_SITE = 'https://yxzh.watch.life-oasis.com/'

// 通过 UA 判断是否为移动端设备（避免 PC 端缩放窗口误跳转）
function isMobileDevice () {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// 移动端访问时跳转到 H5 站点：首页跳首页，直播页跳对应直播
router.beforeEach((to, from, next) => {
  if (isMobileDevice()) {
    if (to.name === 'liveList') {
      window.location.replace(MOBILE_SITE)
      return
    }
    if (to.name === 'liveView' || to.name === 'liveViewPc' || to.name === 'liveViewH5') {
      const mId = to.params && to.params.id
      if (mId) {
        window.location.replace(`${MOBILE_SITE}pages/livePage/livePage?mId=${mId}&smp=${Date.now()}`)
        return
      }
    }
  }
  next()
})

export default router

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js